var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.loading)?_c('div',{staticClass:"panel"},[_c('div',{staticClass:"spinner-wrapper"},[_c('b-spinner',{staticClass:"spinner",attrs:{"type":"grow","variant":"secondary"}})],1)]):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }